<script setup lang="ts">
import { TeamSide } from '@collector/shared-domain'
import { SubParticipant } from '@collector/sportsapi-types'

interface Props {
  subParticipant: SubParticipant | undefined
  teamSide: TeamSide
  selected?: boolean
}

defineProps<Props>()

// emits
defineEmits(['click'])
</script>

<template>
  <div class="flex h-full w-full flex-col items-center justify-center">
    <div
      class="flex flex-col items-center select-none"
      :class="{
        [`${$attrs.itemClass}`]: $attrs.itemClass,
      }"
      @click="$emit('click')"
    >
      <div
        class="relative rounded-full transition-all"
        :class="{
          'h-[7vw] w-[7vw] @md:h-14 @md:w-14': !selected,
          'h-[8vw] w-[8vw] @md:h-[4.5rem] @md:w-[4.5rem]': selected,
          'border-neutral-3': !subParticipant,
          'bg-current-team-home-5':
            teamSide === 'home' && subParticipant && !selected,
          'border-current-team-home-5': teamSide === 'home' && selected,
          'bg-current-team-away-5':
            teamSide === 'away' && subParticipant && !selected,
          'border-current-team-away-5': teamSide === 'away' && selected,
          'bg-neutral-light-10 border-[0.125rem]': !subParticipant || selected,
        }"
      >
        <span
          v-if="subParticipant"
          class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform text-lg"
          :class="{
            'text-neutral-light-10': !selected,
          }"
        >
          {{ subParticipant.shirt_nr }}
        </span>
      </div>
      <div class="text-neutral-light-10 mt-2 h-8 text-center text-sm">
        {{ subParticipant ? subParticipant.short_name : '---' }}
      </div>
    </div>
  </div>
</template>
